module.exports = __webpack_public_path__ + "static/img/aluminum-scrap_64.6c358b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aluminum-scrap_64.png
// module id = 7sLp
// module chunks = 0